/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { observer } from 'mobx-react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V3ThreeCardsModuleComponent } from './code-split/v3-three-cards-module-component';
import { SanityStore } from 'stores/cp-sanity-store';
import { withStores } from 'src/stores';
interface V3ThreeCardsModuleProps { 
  sanityStore: SanityStore;
}
const V3ThreeCardsModule = withStores('sanityStore')(
  observer(({ sanityStore, ...props }: V3ThreeCardsModuleProps) => {
    const componentLayoutType: ComponentLayoutType<any> = { moduleName: props['moduleName'] || '', ...props };
    return (
      <>
        {!sanityStore?.isHideThreeUp && (
          <ComponentLayout {...componentLayoutType}>
            <V3ThreeCardsModuleComponent />
          </ComponentLayout>
        )}
      </>
    );
  })
);

const V3ThreeFilterCardsModule: React.FC<ComponentLayoutType<any>> = (props) => {
  return (
    <ComponentLayout {...props}>
      <V3ThreeCardsModuleComponent />
    </ComponentLayout>
  );
};

export { V3ThreeFilterCardsModule };
export default V3ThreeCardsModule;
